import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { PlantIdRequest } from '@gtpl/shared-models/masters';
import { AssertIdRequest, CommonResponse, SoakingTubResponseModel } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { getManager } from 'typeorm';
import { SoakingRequestDto } from './dto/soaking-request.dto';
import { SoakingAdapter } from './dto/soaking.adapter';
import { Soaking } from './soaking.entity';
import { SoakingRepository } from './soaking.repository';
import {ForkLiftJobService} from '@gtpl/shared-services/warehouse-management'
import { Cron } from '@nestjs/schedule';
@Injectable()
export class SoakingService {
    constructor(
        @InjectRepository(SoakingRepository) private soakingRepository: SoakingRepository,
        private soakingAdapter: SoakingAdapter,
        private forkLiftJobService: ForkLiftJobService,

    ) { }

    async createSoaking(req: SoakingRequestDto, isUpdate: boolean,request:Request): Promise<SoakingTubResponseModel> {
        try {
            console.log(isUpdate);
            if (!isUpdate) {
            const convertedSoskingEntity: Soaking = this.soakingAdapter.convertDtoToEntity(req,isUpdate);
            const savedSoakingEntity: Soaking = await this.soakingRepository.save(
            convertedSoskingEntity
            );
            const savedSoakingDto: SoakingRequestDto = this.soakingAdapter.convertEntityToDto(savedSoakingEntity);
            if (savedSoakingDto) {
            // generating resposnse
            const response = new SoakingTubResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'soaking Updated Successfully': 'Soaking Created Successfully',savedSoakingDto);
            return response;
            } else {
            throw new ErrorResponse(11106,'Soaking saved but issue while transforming into DTO');
            }
         }
        } catch (error) {
            return error;
        }
    }
    async getMachinedetails(req:AssertIdRequest): Promise<CommonResponse> {
        try{
            const manager = getManager()
            let query = await manager.query("Select asset_id AS assetId,asset_name AS assetName from "+appSettings.assets_db+".asset a where asset_code = "+req.assertCode);
            if(query.length > 0){
                return new CommonResponse(true,10001,"Asset Details retrieved successfully", query)
            }
            else{
                return new CommonResponse(false,10101,"No data found")
            }
        }catch (error) {
            return error;
        }
    }
    @Cron('0 */45 * * * *')
    async updateSoakingTubDeviceStatus(req:PlantIdRequest): Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = await manager.query("Select device_id AS deviceId, device_name AS deviceName,plant_id AS plantId from "+appSettings.production_db+".soaking s left join "+appSettings.assets_db+".assets a on a.asset_id = s.assert_id where TIMESTAMPDIFF(MINUTE,`start_time`,`end_time`) >= duration")
            if(query.length > 0){
                const deviceFlagSet = new Set<boolean>();
                for(const item of query){
                    const deviceStatusUpdate = await this.forkLiftJobService.getOperateDevice({on:false,deviceName:'lights',bulbId:item.deviceId,userName:'FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS',hue:100,ip:'192.168.0.166',plantId:item.plantId,status:'1'});
                    if(deviceStatusUpdate.status){
                        deviceFlagSet.add(true)
                    }
                    else{
                        deviceFlagSet.add(false)
                    }
                }
                if(!(deviceFlagSet.has(false))) {
                    return new CommonResponse(true,1001,"Device Status updated");
                }
                else{
                    return new CommonResponse(false,1001,"Failed to update Device Status");
                }
            }
            else{
                return new CommonResponse(false,1001,"Failed to update Device Status");
            }
        }catch (error) {
            return error;
        }
    }

}


